import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { API } from "@service/system/api.service";
import { ResponseHandler } from "@service/system/responseHandler.service";
import { ServiceResponse } from "../data";
import { MaterialsProductLine, MaterialProductLineCourseVersionMetaData, MaterialProductLineLearningActivityMetaData } from "../data/marketingMaterials";

const API_URL = API.API_URL;

@Injectable()
export class MarketingMaterialService {
  constructor(private responseHandler: ResponseHandler) { }

  getProductLines(): Observable<ServiceResponse<MaterialsProductLine[]>> {
    return this.responseHandler.httpGet<MaterialsProductLine[]>(`${API_URL}/materials/productlines`);
  }

  getMaterialsProductVersionMetadata(plitemid: string):  Observable<ServiceResponse<MaterialProductLineCourseVersionMetaData[]>> {
    return this.responseHandler.httpGet<MaterialProductLineCourseVersionMetaData[]>(`${API_URL}/materials/metadata/course`, { plitemid: plitemid });
  }

  getMaterialsLearningActivityMetadata(plitemid: string):  Observable<ServiceResponse<MaterialProductLineCourseVersionMetaData[]>> {
    return this.responseHandler.httpGet<MaterialProductLineCourseVersionMetaData[]>(`${API_URL}/materials/metadata/activity`, { plitemid: plitemid });
  }
}
